import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import type { AdminTenant } from "./tenants.types";

export const adminTenantsQueryOptions = queryOptions({
	queryKey: ["admin", "tenants"],
	queryFn: () => api.get<AdminTenant[]>("/platform/admin/tenants"),
});
